import { Box, Paper, Typography, Chip, IconButton, Button, LinearProgress, Divider } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from "../../../../../../../components/PermissionGuard";
import { IDataPublicos } from "../../../../../../../types/api/geral/pesquisar-publicos";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import { useMemo, useState, useContext } from "react";
import { useDetalhePublico } from "../../../../../../../contexts/DialogsContext/DetalhePublicoContext";
import FazendaSection from "./FazendaSection";
import { AuthContext } from "../../../../../../../contexts/AuthContext";
export default function ClienteCard({
    cliente
}: ClienteCardProps) {
      const hasPermission = usePermission("cadastros.dados-financeiro-do-publico")
    const { tokenDecoded } = useContext(AuthContext)
    const tipo_publico = tokenDecoded?.perfis_vinculados.find(
        (perfil) => (perfil.tipo_publico || "").includes(cliente.tipo_publico)
      );
    const publicoVerificado = hasPermission && tipo_publico?.tipo_publico.some(tp => tp.toLowerCase().trim() === cliente.tipo_publico.toLowerCase().trim())
    const { openModal } = useDetalhePublico()

    const [dadosVisiveis, setDadosVisiveis] = useState<boolean>(false);

    const porcentagemUtilizada = useMemo(() => {
        if (!cliente.limite_utilizado || !cliente.limite_disponivel) return 0;

        return Math.min(
            (Number(cliente.limite_utilizado) / (Number(cliente.limite_utilizado) + Number(cliente.limite_disponivel))) * 100,
            100
        )
    }, [cliente.limite_utilizado, cliente.limite_disponivel]);

    const getBackgroundChip = () => {
        switch (cliente.situacao_financeira) {
            case 'BLOQUEADO DEFINITIVO':
                return '#d32f2f';
            case 'BLOQUEADO':
                return '#ff9800';
            case 'LIBERADO':
                return '#4caf50';
            default:
                return '#2196f3';
        }
    }

    return (
        <Box component={Paper}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pt: 2,
                mx: 2
            }}>
                <Typography variant='h6' component="div">{cliente.nome_pessoa}</Typography>
                {(dadosVisiveis && <Chip size='small' sx={{
                    backgroundColor: getBackgroundChip(), // Cor de fundo
                    color: '#ffffff', // Cor do texto
                    fontSize: '10px', // Tamanho da fonte
                    fontWeight: 'bold', // Peso da fonte
                }}
                    label={cliente.situacao_financeira} />)}
            </Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                mx: 2,
                gap: 1,
                justifyContent: 'space-between'
            }}>
                <Chip
                    icon={<PersonIcon />}
                    label={`${cliente.tipo_publico}${cliente.codigo_publico}`}
                    size="small"
                    clickable
                />

                <IconButton size="small" onClick={() => setDadosVisiveis(!dadosVisiveis)}>
                    {dadosVisiveis ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
            </Box>

            <Box sx={{ mx: 2, mt: 2, pb: 2 }}>
                <Typography variant="subtitle1" fontWeight="medium">
                    Limite de crédito
                </Typography>

                <LinearProgress
                    variant="determinate"
                    color={porcentagemUtilizada === 100 ? 'error' : 'success'}
                    value={porcentagemUtilizada}
                    sx={{
                        height: 6,
                        borderRadius: 0.5
                    }}
                />

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 1
                }}>
                    <Box>
                        <Typography variant="body2" color="text.secondary">
                            Utilizado
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                            {dadosVisiveis ? formatarValorMonetario(cliente.limite_utilizado ?? 0) : '******'}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" color="text.secondary" align="right">
                            Disponível
                        </Typography>
                        <Typography variant="subtitle1" fontWeight="medium">
                            {dadosVisiveis ? formatarValorMonetario(cliente.limite_disponivel ?? 0) : '******'}
                        </Typography>
                    </Box>
                </Box>

                {publicoVerificado && (
                        <Button
                            variant="outlined"
                            fullWidth
                            sx={{ mt: 2 }}
                            onClick={() => openModal(`${cliente.tipo_publico}${cliente.codigo_publico}`)}
                        >
                            Ver detalhes financeiros
                        </Button>
                    )
                }

                <Divider sx={{ my: 2 }} />

                <FazendaSection fazenda={cliente.selected_fazenda} />
            </Box>
        </Box>
    )
}


interface ClienteCardProps {
    cliente: IDataPublicos
}